import { partnersApi } from 'api';
import { AccountSearchResult } from 'pco-product-service-internal-consumer';

// This call allows to retrieve a BRUID from a given account number

export const searchAccount = async (accountNumber: string): Promise<AccountSearchResult> => {
  return await partnersApi.getAccountSearchResult({ accountNumber });
};
